"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDispatchStates = exports.useDispatchMethods = exports.useComponentTypes = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
function useComponentTypes() {
    return list_source_hook_1.useStaticListSource([
        { id: 'MAIN', name: 'Hlavní' },
        { id: 'DELIVERY_NOTE', name: 'Doručenka' },
    ]);
}
exports.useComponentTypes = useComponentTypes;
function useDispatchMethods() {
    return list_source_hook_1.useStaticListSource([
        { id: 'EMAIL', name: 'Email' },
        { id: 'DATABOX', name: 'Datová schránka' },
        { id: 'POSTAL', name: 'Poštovní adresa' },
    ]);
}
exports.useDispatchMethods = useDispatchMethods;
function useDispatchStates() {
    return list_source_hook_1.useStaticListSource([
        { id: 'CREATED', name: 'Vytvořeno' },
        { id: 'SENT', name: 'Odesláno' },
        { id: 'DELIVERED', name: 'Doručeno' },
    ]);
}
exports.useDispatchStates = useDispatchStates;
//# sourceMappingURL=ess-api.js.map